import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import map from 'lodash/map';
import { useTranslation } from 'react-i18next';
import { GeneralPagination } from 'sharedComponents/GeneralPagination';
import { LoadingStatusWrapper } from 'sharedComponents/WithLoadingStatus';
import { eventStatus } from '../../constants';
import { pageSize } from './constants';
import { formatDateTime } from 'helpers/dateTimeFormatter';

const EventDetailsSSCommentList = ({ model, selectedPage, setSelectedPage, displayedComments }) => {
    const { t: translate } = useTranslation();
    return (
        <Col
            className='event-details-comments'
            xl={model.selectedEvent?.rawEvent?.status === eventStatus.CLOSED ? 12 : 7}
            xs={12}
        >
            <div className='event-comments-label'>
                {translate('ABB.Powertrain.Frontend.eventDetailsEventCommentsLbl')}
            </div>
            <LoadingStatusWrapper
                loadingStatus={model.eventComments.loadingStatus}
            >
                {model.eventComments?.data?.length > 0 && displayedComments ?
                    <>
                        {map(displayedComments, (comment, i) => {
                            return (
                                <div
                                    className='event-details-comment'
                                    key={`key${i}`}
                                >
                                    <div className='comment-user-time'>
                                        {comment?.authorEmail && comment.authorEmail} |{' '}
                                        {comment?.timestamp && formatDateTime(comment.timestamp)}
                                    </div>
                                    <div className='user-comment'>
                                        {comment?.text}
                                    </div>
                                </div>
                            );
                        })}
                        <GeneralPagination
                            currentPage={selectedPage}
                            total={model.eventComments?.data?.length}
                            pageSize={pageSize}
                            onChange={setSelectedPage}
                            hideOnSinglePage={true}
                        />
                    </>
                    :
                    <div className='no-comment-available'>
                        {translate('ABB.Powertrain.Frontend.noInformationAvailableLabel')}
                    </div>
                }
            </LoadingStatusWrapper>
        </Col>
    );
};

EventDetailsSSCommentList.propTypes = {
    model: PropTypes.shape({
        eventComments: PropTypes.shape({
            loadingStatus: PropTypes.string, // Loading status of the event comments
            data: PropTypes.arrayOf(
                PropTypes.shape({
                    authorEmail: PropTypes.string, // Email of the comment author
                    timeStamp: PropTypes.string, // Timestamp of the comment
                    text: PropTypes.string, // Text of the comment
                })
            ), // Array of event comments
        }), // Event comments data
        selectedEvent: PropTypes.shape({
            rawEvent: PropTypes.shape({
                status: PropTypes.string, // Status of the event (e.g., CLOSED)
            }), // Raw event details
        }), // Selected event details
    }), // Model containing state data
    selectedPage: PropTypes.number, // Current page number for pagination
    setSelectedPage: PropTypes.func, // Function to set the selected page
    displayedComments: PropTypes.arrayOf(
        PropTypes.shape({
            authorEmail: PropTypes.string, // Email of the comment author
            timestamp: PropTypes.string, // Timestamp of the comment
            text: PropTypes.string, // Text of the comment
        })
    ), // Array of displayed comments
};

export default EventDetailsSSCommentList;
